(function() {
	if ($('#karteFormAusbildung').length) {

		var map = null;
		var pinIcon = null;
		var mapMarkers = [];

		initTrainingsForm = function(formClass) {
			var form = $('#' + formClass);
			form.find('#category').change(function(){
				childCategoryElement = form.find('#childCategory');
				childCategoryElement.find('option').hide();
				childCategoryElement.attr('disabled', true);
				if ($(this).val()) {
					childCategoryElement.removeAttr('disabled');
					childCategoryElement.find('option[data-default="1"]').show();
					childCategoryElement.find('option[data-parent="' + $(this).val() + '"]').show();
				}
			});
			form.submit(function(e) {
				e.preventDefault();
				var form = $(this);
				var submitUrl = $(this).find('button').data('submit');
				$.ajax({
					type: 'POST',
					url: submitUrl,
					data: $(this).serialize(),
					dataType : "json",
					success: function(response) {
						console.log(response.length);
						if (response.length > 0) {
							form.siblings('.noresult').addClass('d-none');
						} else {
							form.siblings('.noresult').removeClass('d-none');
						}
						displayTrainingsMarkers(response);
					}
				});
			});
		}

		initTrainingsMap = function(parentClass, mapId) {
			map = L.map(mapId).setView([51.351, 10.454], 6);
			L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 19,
				attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			}).addTo(map);
			pinIcon = L.icon({
				iconUrl: $('.' + parentClass).data('mapmarker'),
				shadowUrl: '',
				iconSize:     [38, 95],
				iconAnchor:   [22, 94],
				popupAnchor:  [-3, -76]
			});

		}
		displayTrainingsMarkers = function(mapMarkersData) {
			if (mapMarkers !== null) {
				$.each(mapMarkers, function(index, mapMarker) {
					map.removeLayer(mapMarker);
				});
			}
			if (typeof mapMarkersData !== 'undefined') {
				$.each(mapMarkersData, function (index, markerData) {
					var markerData = markerData;
					var marker = L.marker(
						[this.latitude, this.longitude],
						{icon: pinIcon}
					).addTo(map).on('click', function () {
						window.document.location.href = markerData.url;
					});
					mapMarkers.push(marker);
				})
			}
		}

		initTrainingsForm('karteFormAusbildung');
		initTrainingsMap('map-show', 'karte-map')
		displayTrainingsMarkers(mapMarkersData);
	}
	if ($('.section-stellenanzeige').length) {
		var mapContainer = $('#map');
		var pinLatitude = mapContainer.data('latitude');
		var pinLongitude = mapContainer.data('longitude');
		map = L.map('map').setView([pinLatitude, pinLongitude], 12);
		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			maxZoom: 19,
			attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
		}).addTo(map);
		pinIcon = L.icon({
			iconUrl: mapContainer.data('mapmarker'),
			shadowUrl: '',
			iconSize:     [38, 95],
			iconAnchor:   [22, 94],
			popupAnchor:  [-3, -76]
		});
		L.marker(
			[pinLatitude, pinLongitude],
			{icon: pinIcon}
		).addTo(map);
	}
})();
